import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesNewRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-new',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
	query: ['parentId?'],
	exact: true,
};
